var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider__card"},[_c('img',{attrs:{"src":require("@/assets/images/slider-item-imgs/ico226.svg"),"alt":"ico226.svg"}}),_c('div',{staticClass:"text-container"},[_c('text-string',{attrs:{"label-id":"txt1437"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }